import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

// Card-shaped placeholders instead of a bare centred spinner: the list keeps its
// geometry while loading, so nothing jumps when the data lands.
const FixtureSkeleton = ({ isMobile, rows = 6 }) => (
  <Box sx={{ px: isMobile ? 1.5 : 3, pt: 2, pb: 3 }}>
    <Skeleton variant="text" width={140} height={18} sx={{ mb: 1.5 }} />
    {Array.from({ length: rows }).map((_, i) => (
      <Card key={i} sx={{ mb: 1.5 }}>
        <CardContent sx={{ p: isMobile ? 1.5 : 2, '&:last-child': { pb: isMobile ? 1.5 : 2 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Skeleton variant="circular" width={isMobile ? 28 : 32} height={isMobile ? 28 : 32} />
            <Skeleton variant="text" sx={{ flex: 1 }} height={18} />
            <Skeleton variant="text" width={44} height={22} />
            <Skeleton variant="text" sx={{ flex: 1 }} height={18} />
            <Skeleton variant="circular" width={isMobile ? 28 : 32} height={isMobile ? 28 : 32} />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.75 }}>
            <Skeleton variant="text" width={90} height={14} />
            <Skeleton variant="text" width={130} height={14} />
          </Box>
        </CardContent>
      </Card>
    ))}
  </Box>
);

export default FixtureSkeleton;
